import { useStoreService } from "../../service/store/index";
import { useEffect, useState } from "react";
import { IStore } from "../../utils/interfaces/IStore";
import { useNotificationSnackbar } from "../useNotificationSnackbar";

const useGetAllStore = () => {
  const [data, setData] = useState<IStore[]>([]);
  const [error, setError] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { onErrorSnackbar } = useNotificationSnackbar();
  const { getAllStore } = useStoreService();
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllStore();
      if(response?.status === 200) {
        setData(response?.data);
    }
    else {
      onErrorSnackbar(response.data)
    }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestUpdate = () => {
    fetchData();
  };

  return {
    data,
    error,
    isLoading,
    requestUpdate,
  };
};

export default useGetAllStore;
